export enum DownloadAnswerFormat {
  Pdf = 'pdf',
  Spreadsheet = 'spreadsheet',
}
